import React, { useState } from "react";
import { Icon } from "@iconify/react";

// Mockup blog data
const blogData = [
  {
    id: 1,
    image:
      "https://pcdnaskme.click/66fbb364178bee5dee1b7776/media/banner/13018a7a-49a7-11f0-8ae9-4ab7df12f575.jpg",
    title: "วิธีเล่นสล็อตออนไลน์ให้ได้เงิน 5 เทคนิคจากผู้เชี่ยวชาญ",
    shortDetail:
      "รวมเทคนิคการเล่นสล็อตออนไลน์ที่ผู้เชี่ยวชาญแนะนำ เพื่อเพิ่มโอกาสชนะและทำกำไรอย่างยั่งยืน",
    fullDetail:
      "การเล่นสล็อตออนไลน์ให้ได้เงินไม่ใช่เรื่องยาก หากคุณมีเทคนิคที่ถูกต้อง 1. ศึกษา RTP ของเกมก่อนเล่น 2. จัดการเงินทุนอย่างมีระบบ 3. เลือกเวลาเล่นที่เหมาะสม 4. ใช้โบนัสอย่างชาญฉลาด 5. รู้จักหยุดเมื่อกำไร เทคนิคเหล่านี้จะช่วยให้คุณเล่นได้อย่างมั่นใจและมีกำไรในระยะยาว",
  },
  {
    id: 2,
    image:
      "https://pcdnaskme.click/66fbb364178bee5dee1b7776/media/banner/13018a7a-49a7-11f0-8ae9-4ab7df12f575.jpg",
    title: "เทรนด์เกมคาสิโนออนไลน์ 2024 ที่ต้องลอง",
    shortDetail: "อัพเดทเกมคาสิโนออนไลน์ใหม่ล่าสุดที่กำลังมาแรงในปี 2024",
    fullDetail:
      "ปี 2024 เป็นปีที่เต็มไปด้วยนวัตกรรมใหม่ในวงการคาสิโนออนไลน์ ไม่ว่าจะเป็นเกมสล็อต 3D ที่มีกราฟิกสวยงาม เกมยิงปลาที่มีฟีเจอร์ใหม่ เกมไพ่ที่รองรับ VR และเกมเดิมพันกีฬาที่มีตัวเลือกมากขึ้น ร่วมสำรวจเทรนด์เหล่านี้และเลือกเกมที่เหมาะกับสไตล์การเล่นของคุณ",
  },
  {
    id: 3,
    image:
      "https://pcdnaskme.click/66fbb364178bee5dee1b7776/media/banner/13018a7a-49a7-11f0-8ae9-4ab7df12f575.jpg",
    title: "การจัดการเงินทุนในการเดิมพันออนไลน์",
    shortDetail: "เทคนิคการจัดการเงินทุนที่นักเดิมพันมืออาชีพใช้",
    fullDetail:
      "การจัดการเงินทุนเป็นหัวใจสำคัญของการเดิมพันที่ประสบความสำเร็จ กฎ 50/30/20: ใช้ 50% สำหรับเดิมพันหลัก 30% สำหรับเดิมพันเสี่ยง 20% เก็บไว้เป็นทุนสำรอง กำหนดเป้าหมายกำไรและขาดทุนที่ชัดเจน ไม่เดิมพันเกินความสามารถ และเลือกเกมที่มีอัตราผลตอบแทนสูง",
  },
  {
    id: 4,
    image:
      "https://pcdnaskme.click/66fbb364178bee5dee1b7776/media/banner/13018a7a-49a7-11f0-8ae9-4ab7df12f575.jpg",
    title: "รีวิวเกมสล็อตยอดนิยม: Gates of Olympus",
    shortDetail: "รีวิวละเอียดเกมสล็อต Gates of Olympus ที่กำลังฮิต",
    fullDetail:
      "Gates of Olympus เป็นเกมสล็อตที่ได้รับความนิยมสูงสุดในปัจจุบัน ด้วยระบบ Cascading Reels และฟีเจอร์ Multiplier ที่ทำให้ผู้เล่นตื่นเต้น RTP อยู่ที่ 96.5% มีโบนัสฟรีสปินสูงสุด 15 รอบ และโอกาสชนะแจ็คพอตสูง เหมาะสำหรับผู้เล่นทุกระดับ",
  },
  {
    id: 5,
    image:
      "https://pcdnaskme.click/66fbb364178bee5dee1b7776/media/banner/13018a7a-49a7-11f0-8ae9-4ab7df12f575.jpg",
    title: "ความปลอดภัยในการเล่นพนันออนไลน์",
    shortDetail: "คู่มือเล่นพนันออนไลน์อย่างปลอดภัยและรับผิดชอบ",
    fullDetail:
      "การเล่นพนันออนไลน์อย่างปลอดภัยเริ่มต้นจากการเลือกเว็บไซต์ที่มีใบอนุญาตถูกต้อง มีระบบรักษาความปลอดภัยขั้นสูง กำหนดขีดจำกัดการเล่น ไม่เล่นเมื่ออารมณ์ไม่ดี และขอความช่วยเหลือเมื่อจำเป็น ความรับผิดชอบต่อตนเองคือกุญแจสำคัญของการเดิมพันที่ยั่งยืน",
  },
  {
    id: 6,
    image:
      "https://pcdnaskme.click/66fbb364178bee5dee1b7776/media/banner/13018a7a-49a7-11f0-8ae9-4ab7df12f575.jpg",
    title: "เคล็ดลับเล่นบาคาร่าออนไลน์ให้ชนะ",
    shortDetail: "กลยุทธ์และเทคนิคการเล่นบาคาร่าสำหรับมือใหม่และมืออาชีพ",
    fullDetail:
      "บาคาร่าเป็นเกมไพ่ที่เล่นง่ายแต่ต้องใช้กลยุทธ์ ให้ความสำคัญกับการจัดการเงินทุน เลือกเดิมพัน Banker เมื่อไม่แน่ใจ หลีกเลี่ยงการเดิมพัน Tie เพราะมี House Edge สูง ใช้สูตรการเดิมพันแบบ Martingale อย่างระมัดระวัง และสังเกตรูปแบบการออกไพ่",
  },
  {
    id: 7,
    image:
      "https://pcdnaskme.click/66fbb364178bee5dee1b7776/media/banner/13018a7a-49a7-11f0-8ae9-4ab7df12f575.jpg",
    title: "อนาคตของคาสิโนออนไลน์ในยุค Metaverse",
    shortDetail: "สำรวจอนาคตของการเดิมพันออนไลน์ในโลกเสมือนจริง",
    fullDetail:
      "Metaverse กำลังเปลี่ยนแปลงอุตสาหกรรมคาสิโนออนไลน์ ด้วยเทคโนโลยี VR และ AR ที่ให้ประสบการณ์การเล่นที่สมจริง ผู้เล่นสามารถปฏิสัมพันธ์กับผู้เล่นอื่นและดีลเลอร์ในสภาพแวดล้อมสามมิติ การใช้ Cryptocurrency และ NFT ก็เริ่มเข้ามามีบทบาทในการเดิมพัน",
  },
  {
    id: 8,
    image:
      "https://pcdnaskme.click/66fbb364178bee5dee1b7776/media/banner/13018a7a-49a7-11f0-8ae9-4ab7df12f575.jpg",
    title: "เทคนิคการเล่นเกมยิงปลาให้ได้เงิน",
    shortDetail: "วิธีเล่นเกมยิงปลาอย่างมีกลยุทธ์เพื่อเพิ่มโอกาสชนะ",
    fullDetail:
      "เกมยิงปลาไม่ใช่แค่เกมแห่งโชค แต่ต้องใช้ทักษะและกลยุทธ์ เลือกปลาที่เหมาะสมกับเงินทุน เริ่มต้นด้วยปลาเล็กเพื่อสะสมทุน ใช้กระสุนพิเศษอย่างชาญฉลาด สังเกตรูปแบบการว่ายของปลา และเล่นในช่วงเวลาที่เหมาะสม",
  },
  {
    id: 9,
    image:
      "https://pcdnaskme.click/66fbb364178bee5dee1b7776/media/banner/13018a7a-49a7-11f0-8ae9-4ab7df12f575.jpg",
    title: "การเดิมพันกีฬาออนไลน์ 101",
    shortDetail: "คู่มือเริ่มต้นการเดิมพันกีฬาออนไลน์สำหรับมือใหม่",
    fullDetail:
      "การเดิมพันกีฬาออนไลน์เป็นหนึ่งในรูปแบบการเดิมพันที่ได้รับความนิยมสูง เริ่มต้นด้วยการศึกษาข้อมูลทีมและนักกีฬา เข้าใจระบบราคาต่อรอง เลือกลีกที่คุณคุ้นเคย จัดการเงินทุนอย่างรัดกุม และไม่ให้อารมณ์เข้ามาแทรกแซงการตัดสินใจ",
  },
  {
    id: 10,
    image:
      "https://pcdnaskme.click/66fbb364178bee5dee1b7776/media/banner/13018a7a-49a7-11f0-8ae9-4ab7df12f575.jpg",
    title: "ระบบโบนัสและโปรโมชั่นคาสิโนออนไลน์",
    shortDetail: "เข้าใจระบบโบนัสและโปรโมชั่นเพื่อใช้ประโยชน์สูงสุด",
    fullDetail:
      "โบนัสและโปรโมชั่นเป็นเครื่องมือสำคัญในการเพิ่มทุนการเล่น แต่ต้องเข้าใจเงื่อนไขการใช้งาน อ่านรายละเอียด Wagering Requirement ให้ครบถ้วน เลือกโบนัสที่เหมาะกับสไตล์การเล่น วางแผนการใช้โบนัสอย่างมีกลยุทธ์ และไม่หลงใหลในโบนัสจนลืมการจัดการเงินทุน",
  },
];

const Blog = () => {
  const [selectedBlog, setSelectedBlog] = useState(null);

  const handleReadMore = (blog) => {
    setSelectedBlog(blog);
  };

  const handleBackToList = () => {
    setSelectedBlog(null);
  };

  // If a blog is selected, show detailed view
  if (selectedBlog) {
    return (
      <div
        style={{
          padding: "16px",
          color: "#fff",

          margin: "24px",
          borderRadius: "8px",
        }}
      >
        <div style={{ marginBottom: "20px" }}>
          <button
            onClick={handleBackToList}
            style={{
              background: "linear-gradient(135deg, #6b7280, #9ca3af)",
              border: "none",
              borderRadius: "8px",
              padding: "12px 20px",
              color: "white",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "20px",
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1)";
            }}
          >
            <Icon icon="mdi:arrow-left" width="16" height="16" />
            กลับไปบทตวามทั้งหมด
          </button>
        </div>

        <div
          style={{
            backgroundColor: "#2d2d2d",
            borderRadius: "12px",
            overflow: "hidden",
            border: "1px solid #404040",
          }}
        >
          <img
            src={selectedBlog.image}
            alt={selectedBlog.title}
            style={{
              width: "100%",
              height: "300px",
              objectFit: "cover",
            }}
            onError={(e) => {
              e.target.src =
                "https://via.placeholder.com/800x300/2d2d2d/f59e0b?text=Promotion+Image";
            }}
          />
          <div style={{ padding: "30px" }}>
            <h1
              style={{
                color: "#f59e0b",
                fontSize: "28px",
                marginBottom: "20px",
                lineHeight: "1.4",
              }}
            >
              {selectedBlog.title}
            </h1>
            <div
              style={{
                color: "#e5e7eb",
                fontSize: "16px",
                lineHeight: "1.8",
                marginBottom: "30px",
              }}
            >
              {selectedBlog.fullDetail}
            </div>
          </div>
        </div>
        <div style={{ marginTop: "32px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            <h2
              style={{
                color: "#f59e0b",
                margin: "0",
                fontSize: "24px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <Icon
                icon="ph:read-cv-logo-duotone"
                width="40"
                height="40"
                style={{ color: "#f59e0b" }}
              />
              บทความเพิ่มเติม
            </h2>
          </div>
        </div>
        <hr style={{ border: "1px solid #404040", marginBottom: "20px" }} />
        {/* More Blog posts list */}
        <div
          className="promotion-grid"
          style={{
            display: "grid",
            gap: "24px",
            gridTemplateColumns: "repeat(3, 1fr)",
          }}
        >
          {blogData
            .filter((blog) => blog.id !== selectedBlog.id)
            .slice(0, 3)
            .map((blog) => (
              <div
                key={blog.id}
                style={{
                  backgroundColor: "#2d2d2d",
                  borderRadius: "12px",
                  overflow: "hidden",
                  border: "1px solid #404040",
                  transition: "all 0.3s ease",
                }}
              >
                <img
                  src={blog.image}
                  alt={blog.title}
                  style={{
                    width: "100%",
                    height: "150px",
                    objectFit: "cover",
                  }}
                  onError={(e) => {
                    e.target.src =
                      "https://via.placeholder.com/400x150/2d2d2d/f59e0b?text=Blog+Image";
                  }}
                />
                <div style={{ padding: "16px" }}>
                  <h3
                    style={{
                      color: "#f59e0b",
                      fontSize: "16px",
                      marginBottom: "8px",
                      lineHeight: "1.4",
                      textAlign: "left",
                    }}
                  >
                    {blog.title}
                  </h3>
                  <p
                    style={{
                      color: "#ccc",
                      fontSize: "12px",
                      lineHeight: "1.6",
                      marginBottom: "12px",
                      textAlign: "left",
                    }}
                  >
                    {blog.shortDetail.substring(0, 80)}...
                  </p>
                  <button
                    onClick={() => setSelectedBlog(blog)}
                    style={{
                      background: "transparent",
                      border: "1px solid #f59e0b",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      color: "#f59e0b",
                      fontSize: "12px",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#f59e0b";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "transparent";
                      e.target.style.color = "#f59e0b";
                    }}
                  >
                    อ่านเพิ่มเติม
                    <Icon icon="mdi:chevron-right" width="14" height="14" />
                  </button>
                </div>
              </div>
            ))}
        </div>

        <style>
          {`
            @media (max-width: 768px) {
              h1 {
                font-size: 22px !important;
              }
              h3 {
                font-size: 16px !important;
              }
            }
          `}
        </style>
      </div>
    );
  }

  // Default list view
  return (
    <div
      style={{
        padding: "16px",
        color: "#fff",

        margin: "24px",
        borderRadius: "8px",
      }}
    >
      <div style={{ marginTop: "10px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <h1
            style={{
              color: "#f59e0b",
              margin: "0",
              fontSize: "32px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <Icon
              icon="ph:read-cv-logo-duotone"
              width="40"
              height="40"
              style={{ color: "#f59e0b" }}
            />
            บทความ
          </h1>
        </div>
      </div>
      <hr style={{ border: "1px solid #404040", marginBottom: "20px" }} />
      {/* Blog posts list */}
      <div
        className="promotion-grid"
        style={{
          display: "grid",
          gap: "24px",
          gridTemplateColumns: "repeat(3, 1fr)",
        }}
      >
        {blogData.map((blog) => (
          <div
            key={blog.id}
            style={{
              backgroundColor: "#2d2d2d",
              borderRadius: "12px",
              overflow: "hidden",
              border: "1px solid #404040",
              transition: "all 0.3s ease",
            }}
          >
            <img
              src={blog.image}
              alt={blog.title}
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
              }}
              onError={(e) => {
                e.target.src =
                  "https://via.placeholder.com/400x200/2d2d2d/f59e0b?text=Blog+Image";
              }}
            />
            <div style={{ padding: "20px" }}>
              <h2
                style={{
                  color: "#f59e0b",
                  fontSize: "20px",
                  marginBottom: "12px",
                  lineHeight: "1.4",
                  textAlign: "left",
                }}
              >
                {blog.title}
              </h2>
              <p
                style={{
                  color: "#ccc",
                  fontSize: "14px",
                  lineHeight: "1.6",
                  marginBottom: "16px",
                  textAlign: "left",
                }}
              >
                {blog.shortDetail}
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "left",
                }}
              >
                <button
                  onClick={() => handleReadMore(blog)}
                  style={{
                    background: "transparent",
                    border: "2px solid #f59e0b",
                    borderRadius: "8px",
                    padding: "8px 16px",
                    color: "#f59e0b",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginTop: "16px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#f59e0b";
                    e.target.style.color = "white";
                    e.target.style.transform = "scale(1.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "transparent";
                    e.target.style.color = "#f59e0b";
                    e.target.style.transform = "scale(1)";
                  }}
                >
                  อ่านเพิ่มเติม
                  <Icon icon="mdi:chevron-right" width="16" height="16" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <style>
        {`
          @media (max-width: 768px) {
            h1 {
              font-size: 24px !important;
            }
            h2 {
              font-size: 18px !important;
            }
            
            .promotion-grid {
              grid-template-columns: 1fr !important;
              gap: 16px !important;
            }
          }
          
          @media (min-width: 769px) and (max-width: 1024px) {
            .promotion-grid {
              grid-template-columns: repeat(2, 1fr) !important;
              gap: 20px !important;
            }
          }
          
          @media (min-width: 1025px) {
            .promotion-grid {
              grid-template-columns: repeat(3, 1fr) !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Blog;
